import { EnvironmentState } from "@/store/modules/environment/environmentModule.class";
import { getState } from "../vueInstance";

export default function getEnv(): EnvironmentState {
    return getState().environment;
}